export default "__VITE_PUBLIC_ASSET__18879925__"